@if(message){
  <div [ngClass]="{'show': show}"
       class="card snackbar">
    {{message}}
  </div>
}
